import React from "react";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import TableSortLabel from "@mui/material/TableSortLabel";

type Preferences = {
    id: string
    width: number
}

interface EnhancedTableProps {
    numSelected: number;
    onRequestSort: (event: React.MouseEvent<unknown>, property: string ) => void;
    orderBy: string;
    rowCount: number;
    headCells: HeaderCell[];
    count: number;
    preferences: Preferences[]
    checkboxesWidth: string;
    paddingIsEqual?: boolean
}


export type HeaderCell = {
    id: string
    numeric: boolean
    disablePadding: boolean
    label: React.ReactNode
}

const EnhancedTableHead = (props: EnhancedTableProps) => {
  const {orderBy, numSelected, rowCount, onRequestSort, headCells, count, paddingIsEqual } =
        props;

  const getArrowDirection = (headCell: HeaderCell) => {
    if (orderBy.includes(headCell.id)){
      return headCell.id === orderBy ? 'desc' : 'asc';
    }

    return undefined
  }

  return (
    <TableHead>
      <TableRow>
        <TableCell padding='checkbox' sx={{ width: props.checkboxesWidth, padding: '0 0 0 8px' }} />
        {headCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={getArrowDirection(headCell)}
            style={{ width: props.preferences[index].width }}
            sx={{
              padding: '24px 0',
              '.MuiTableSortLabel-icon': {
                display: index + 1 === headCells.length ? 'none' : 'inline-block',
              }
            }}
          >
            <TableSortLabel
              active={orderBy.includes(headCell.id)}
              direction={getArrowDirection(headCell)}
              sx={{ fontWeight: '500' }}
              onClick={(event) => onRequestSort(event, headCell.id == orderBy ? `-${headCell.id}` : headCell.id)}
            >
              {headCell.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default EnhancedTableHead
